import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';

// ─── Build-Marker (zeigt in Console an dass neues Bundle geladen ist) ───
// eslint-disable-next-line no-console
console.log('%c[DV-Portal v2] Build geladen — ' + new Date().toISOString(),
  'background:#d97706;color:#fff;padding:4px 10px;border-radius:4px;font-weight:bold');

// ─── Globaler Error-Overlay (fängt ALLES ab, auch was ErrorBoundary verpasst) ───
function escapeHtml(s) {
  return String(s).replace(/[<>&"']/g, c => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;', "'": '&#39;' }[c]));
}

function showGlobalError(title, error) {
  const id = '__dv_err_overlay__';
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('div');
    el.id = id;
    el.setAttribute('style',
      'position:fixed;inset:0;z-index:2147483647;background:#0d0d0d;color:#f5f5f5;' +
      'padding:24px;overflow:auto;font-family:system-ui,Arial,sans-serif;box-sizing:border-box');
    document.body.appendChild(el);
  }

  const msg = escapeHtml(error?.message || String(error || '(unbekannt)'));
  const stack = escapeHtml(error?.stack || '(kein Stack)');

  el.innerHTML =
    '<div style="max-width:900px;margin:0 auto">' +
      '<h1 style="color:#d97706;margin:0 0 8px 0;font-size:22px">⚠️ ' + escapeHtml(title) + '</h1>' +
      '<p style="color:#bbb;font-size:14px;line-height:1.5;margin:0 0 18px 0">' +
        'Die App ist gecrasht. Bitte <strong>Screenshot</strong> dieser Seite an Claude schicken.' +
      '</p>' +
      '<div style="background:#1a1a1a;border:1px solid #c2410c;border-radius:8px;padding:14px;margin-bottom:10px">' +
        '<div style="color:#d97706;font-size:11px;text-transform:uppercase;letter-spacing:.5px;font-weight:700;margin-bottom:6px">Fehler</div>' +
        '<pre style="margin:0;white-space:pre-wrap;word-break:break-word;color:#fca5a5;font-size:13px;font-family:Consolas,Menlo,monospace">' + msg + '</pre>' +
      '</div>' +
      '<div style="background:#1a1a1a;border:1px solid #333;border-radius:8px;padding:14px">' +
        '<div style="color:#d97706;font-size:11px;text-transform:uppercase;letter-spacing:.5px;font-weight:700;margin-bottom:6px">Stack-Trace</div>' +
        '<pre style="margin:0;white-space:pre-wrap;word-break:break-word;font-size:12px;color:#e5e5e5;font-family:Consolas,Menlo,monospace">' + stack + '</pre>' +
      '</div>' +
      '<button onclick="window.location.reload()" ' +
        'style="margin-top:20px;background:#d97706;color:#fff;border:none;padding:11px 22px;border-radius:6px;cursor:pointer;font-weight:600;font-size:14px">' +
        'Seite neu laden' +
      '</button>' +
    '</div>';
}

window.addEventListener('error', (e) => {
  // eslint-disable-next-line no-console
  console.error('[Global error]', e.error || e.message);
  showGlobalError('JavaScript-Fehler abgefangen', e.error || new Error(e.message || 'Unbekannter Fehler'));
});

window.addEventListener('unhandledrejection', (e) => {
  // eslint-disable-next-line no-console
  console.error('[Unhandled promise]', e.reason);
  showGlobalError('Unhandled Promise abgefangen',
    e.reason instanceof Error ? e.reason : new Error(String(e.reason)));
});

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
